import {BASE_PATH, BASE_PATH_EXTENSION_ADMIN}  from "../../utils/constants";
import {getToken} from "../Auth/token";
import axios from "axios";

const baseUrl = `${BASE_PATH}${BASE_PATH_EXTENSION_ADMIN}/manager`;

export function getApiManagerAssignedWorkers(managerId) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.get(`${baseUrl}/${managerId}/workers`, config);
}

export function getApiManagerAssignWorker({ manager_id, user_id }) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${baseUrl}/assign-worker`, { manager_id, user_id }, config);
}

export function getApiManagerRemoveWorker({ manager_id, user_id }) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${baseUrl}/remove-worker`, { manager_id, user_id }, config);
}
